export default class ERC20 {
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.symbol = data.symbol;
        this.decimals = data.decimals;
    }
}
